import styled from "styled-components";
import { Button } from "antd";

export const Container = styled.div``;

export const Message = styled.span`
  color: ${({ theme }) => theme.message.color};
  font-size: ${({ theme }) => theme.fontSizes[3]}px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const Description = styled.span`
  color: ${({ theme }) => theme.message.color};
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  li {
    text-align: left;
    list-style: inherit;
    margin-left: 20px;
  }
`;

export const StyledButton = styled(Button)`
  margin: 10px auto;
  padding: ${({ theme }) => theme?.buttons?.submit?.padding};
  width: fit-content;
  background: ${({ theme }) => theme?.buttons?.submit?.background};
  box-shadow: ${({ theme }) => theme?.buttons?.submit?.shadow};
  border-radius: ${({ theme }) => theme?.buttons?.submit?.radius};
  font-style: normal;
  font-weight: ${({ theme }) => theme?.buttons?.submit?.weight};
  font-size: ${({ theme }) => theme?.buttons?.submit?.fontSize};
  line-height: ${({ theme }) => theme?.buttons?.submit?.lineHeight};
  text-transform: capitalize;
  color: ${({ theme }) => theme?.buttons?.submit?.color};
  border: none;

  &.ant-btn-default {
    &:not(:disabled):not(.ant-btn-disabled):hover {
      background-color: ${({ theme }) =>
        theme?.buttons?.submit?.hover?.background};
      border: none;
      color: ${({ theme }) => theme?.buttons?.submit?.hover?.color};
    }

    &:not(:disabled):not(.ant-btn-disabled):focus {
      background-color: ${({ theme }) =>
        theme?.buttons?.submit?.focus?.background};
      border: ${({ theme }) => theme?.buttons?.submit?.focus?.border};
      color: ${({ theme }) => theme?.buttons?.submit?.focus?.color};
    }

    &:disabled {
      background-color: ${({ theme }) =>
        theme?.buttons?.submit?.disabled?.background};
      color: ${({ theme }) => theme?.buttons?.submit?.disabled?.color};
      border-color: ${({ theme }) => theme?.buttons?.submit?.disabled?.border};
      opacity: ${({ theme }) => theme?.buttons?.submit?.disabled?.opacity};
    }
  }
`;
export const Ul = styled.ul`
  display: inline-block;
  text-align: left;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  list-style: none;

  li {
    margin: 5px;
  }

  span {
    width: calc(100% - 20px);
  }

  svg {
    margin: 0 5px -5px 0;

    path {
      color: ${({ theme }) => theme.message.color};
    }
  }
`;
export const ErrorNotice = styled.div`
  color: ${({ theme }) => theme.message.color};
  margin-top: 10px;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    font-weight: 500;
  }
`;

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.pallette.blue.primary};
  text-decoration: underline;
  margin: 0 5px;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  line-height: 24px;

  &:hover {
    text-decoration: none;
  }
`;
